import { FormInstance, Popconfirm, Switch } from "antd";
import { useState } from "react";
import { getRecipesForMenu } from "../../services/menuservice";

interface SignatureSwitchProps {
    form: FormInstance;
    menuItemGuid: string;
}

const SignatureSwitch: React.FC<SignatureSwitchProps> = ({ form, menuItemGuid }) => {

    const [recipes, setRecipes] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [showPopconfirm, setShowPopconfirm] = useState(false);

    const fetchRecipesForMenuItem = async () => {
        try {
            setLoading(true);
            const data = await getRecipesForMenu(menuItemGuid);
            setRecipes(data);
        } catch (error) {
            console.error("Error fetching recipe items.", error);
        } finally {
            setLoading(false);
        }
    };

    const handleConfirm = () => {
        form.setFieldValue("signatureItem", true);
        setShowPopconfirm(false);
    };

    const handleCancel = () => {
        form.setFieldValue("signatureItem", false);
        setShowPopconfirm(false);
    };

    const handleToggle = (checked: boolean) => {
        if (checked) {
            // going from false → true, show Popconfirm
            setShowPopconfirm(true);
            fetchRecipesForMenuItem(); // trigger API call immediately
        } else {
            // going from true → false, just set directly
            form.setFieldValue("signatureItem", false);
        }
    };

    return (
        <>
            {showPopconfirm ? (
                <Popconfirm
                    title="Confirm Signature Item"
                    description={
                        <>
                            <p>
                                Marking this item as signature will remove all menu options{" "}
                                <strong>after you save changes</strong>.
                            </p>
                            <h6>Recipe:</h6>
                            {loading ? (
                                <p>Loading recipes...</p>
                            ) : (
                                // <ul>
                                //     {recipes.map((r: any) => (
                                //         <li key={r.guid}>{r.name}</li>
                                //     ))}
                                // </ul>
                                <ol style={{ listStyleType: "none", paddingLeft: 0 }}>
                                    {recipes
                                        .sort((a: any, b: any) => a.prepOrder - b.prepOrder)
                                        .map((r: any) => (
                                            <li key={r.guid}>
                                                <strong>#{r.prepOrder}</strong> {r.name}
                                            </li>
                                        ))}
                                </ol>

                            )}
                        </>
                    }
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    okText="Yes, make it signature"
                    cancelText="Cancel"
                    open={showPopconfirm}
                >
                    <Switch checked={form.getFieldValue("signatureItem")} />
                </Popconfirm>
            ) : (
                <Switch
                    checked={form.getFieldValue("signatureItem")}
                    onChange={handleToggle}
                />
            )}
        </>
    );
};

export default SignatureSwitch;